import { ISnackbarPrompt } from './types';
import { Dispatch } from '../../../../../types/actions';
import { SNACKBAR_BUTTON_NO, SNACKBAR_BUTTON_YES } from '../constants';
import { getDefaultActionEvent } from '../helpers/getDefaultActionEvent';
import { snackbarPromtDefault } from './promtDefault';

export const snackbarPromtYesNo = (
    options: ISnackbarPrompt,
) => {
    return (dispatch: Dispatch) => {
        options.buttons = [
            {
                onClick: () => dispatch(getDefaultActionEvent(options.id, options.actionCancel)),
                text: options.cancelBtnTitle || SNACKBAR_BUTTON_NO
            },
            {
                onClick: () => dispatch(getDefaultActionEvent(options.id, options.actionApply)),
                isPrimary: true,
                text: options.applyBtnTitle || SNACKBAR_BUTTON_YES
            },
        ];
        dispatch(snackbarPromtDefault(options));
    }
};
